import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
export const LinkIcon = (param)=>{
    let { size = 24, testId, style, className } = param;
    return /*#__PURE__*/ _jsx("svg", {
        width: size,
        height: size,
        "data-testid": testId,
        style: style,
        className: className,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ _jsx("path", {
            d: "M18.0036 13.7748L19.0713 12.7071C21.2068 10.5716 21.2138 7.07146 19.0713 4.92893C16.9358 2.79346 13.4357 2.78639 11.2931 4.92893L10.2254 5.99666M5.98983 10.2322L4.92917 11.2929C2.78663 13.4354 2.78663 16.9285 4.92917 19.0711C7.06463 21.2065 10.5648 21.2136 12.7073 19.0711L13.768 18.0104M9.17181 14.8284L14.8287 9.17157",
            stroke: "currentColor",
            strokeWidth: 1.5 * (24 / size),
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
};
